import React from 'react';

export default function CheckoutHotelRoomSource({ name, logo }) {
  return (
    <div className="flex justify-end space-x-3 items-center">
      <div className="text-right text-gray-500 text-xs w-40 break-words">
        {name}
      </div>

      {logo && (
        <img className="h-6 w-6 bg-gray-200 rounded-full" src={logo} alt="" />
      )}
    </div>
  );
}
